<template>
  <div class="box_width" style="padding: 30px 15px 0px">
    <div class="top_display_css">
      <div style="flex: 1">
        <img src="@/assets/logos.png" style="height:70px" />
        <!-- <img src="@/assets/logoImg.png" style="height:70px" /> -->
      </div>
      <div style="flex: 2; display: flex; justify-content: center">
        <div class="search_all">
          <div>
            <el-input
              placeholder="查学校、查专业"
              v-model="search"
              class="input-with-select"
            >
              <el-select v-model="select" slot="prepend" placeholder="请选择">
                <el-option label="学校" value="1"></el-option>
                <el-option label="专业" value="2"></el-option>
                <el-option label="资讯" value="3"></el-option>
              </el-select>
            </el-input>
            <!-- <input type="text" v-model="search" placeholder="查学校、查专业" /> -->
          </div>
          <div @click="topSearch()">搜索</div>
        </div>
      </div>
      <div class="top_login_display_css">
        <div style="margin-right: 10%" @click="regions()">[{{ region }}]</div>
        <!-- 未登录 -->
        <el-button
          v-if="is_login == '登录/注册'"
          type="goon"
          size="mini"
          @click="toLogin()"
          >{{ is_login }}</el-button
        >
        <!-- 已经登录 -->
        <el-dropdown v-else>
          <span class="el-dropdown-link">
            个人中心<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="vipBtn">vip充值</el-dropdown-item>
            <el-dropdown-item @click.native="questionNaire"
              >实力调查问卷</el-dropdown-item
            >
            <el-dropdown-item @click.native="lookMyReport"
              >我的评测报告</el-dropdown-item
            >
            <el-dropdown-item @click.native="loginOut"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 选择标签 -->
    <div class="lists_css_top">
      <div
        class="small_box"
        v-for="(item, index) in lists"
        :key="index"
        :class="{ small_box_bottom: item.path == $route.path }"
        @click="routerPush(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 标签结束 -->
    <!-- 登录弹出层 -->
    <login ref="login" @updateStatus="updateStatus"></login>
    <!-- vip充值弹出层 -->
    <vipRecharge ref="vipRecharge"></vipRecharge>
  </div>
</template>

<script>
import login from "./login.vue";
import vipRecharge from "./vipRecharge.vue";
export default {
  name: "Top",
  components: {
    login,
    vipRecharge
  },
  data() {
    return {
      search: "",
      region: "",
      regionId: "",
      select: "1",
      is_login: "登录/注册", //是否登录
      lists: [
        {
          name: "首页",
          path: "/"
        },
        {
          name: "模拟报志愿",
          path: "/voluntaryFilling"
        },
        {
          name: "查学校",
          path: "/findSchool"
        },
        {
          name: "查专业",
          path: "/findMajor"
        },
        {
          name: "热点资讯",
          path: "/notice"
        },
        // {
        //   name: "高考直播",
        //   path: "",
        // },
        {
          name: "职业评估",
          path: "/occupation"
        },
        {
          name: "调查问卷",
          path: ""
        }
      ]
    };
  },
  created() {
    this.region = localStorage.getItem("region") || "济南";
    this.regionId = localStorage.getItem("regionId") || "101";
    this.is_login = localStorage.getItem("loginAccount")
      ? localStorage.getItem("loginAccount")
      : "登录/注册";
  },
  mounted() {
    this.$bus.$on("region", val => {
      this.region = localStorage.getItem("region") || "济南";
      this.regionId = localStorage.getItem("regionId") || "101";
      this.is_login = localStorage.getItem("loginAccount")
        ? localStorage.getItem("loginAccount")
        : "登录/注册";
    });
  },
  methods: {
    //打开vip充值弹窗
    vipBtn() {
      console.log("打开vip弹窗");
      this.$refs.vipRecharge.dialogVisible = true;
    },
    //跳转到调查问卷
    questionNaire() {
      const { href } = this.$router.resolve({
        path: "/questionNaire"
      });
      window.open(href, "_blank");
    },
    //跳转到报告列表页
    lookMyReport() {
      console.log("点击了报告列表页");
      const { href } = this.$router.resolve({
        path: "/myReport"
      });
      window.open(href, "_blank");
    },
    //更新登录状态
    updateStatus() {
      this.is_login = localStorage.getItem("loginAccount")
        ? localStorage.getItem("loginAccount")
        : "登录/注册";
    },
    // 选择地区
    regions() {
      this.$router.push({
        path: "region"
      });
    },
    //去登录
    toLogin() {
      this.$refs.login.dialogVisible = true;
    },
    //退出登录
    loginOut() {
      this.$confirm("确定退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          localStorage.clear();
          this.is_login = "登录/注册";
          this.$message.success("退出成功");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 搜索
    topSearch() {
      let search = "";
      if (
        this.search != null &&
        typeof this.search !== "undefined" &&
        this.search.trim() !== ""
      ) {
        search = this.search.trim();
      }
      // if (!search) return;
      if (this.select == "1") {
        if (this.$route.path == "/findSchool") {
          this.$bus.$emit("findSchool", search);
        } else {
          this.$router.push({
            path: "findSchool",
            query: {
              search: search
            }
          });
        }
      } else if (this.select == "2") {
        if (this.$route.path == "/findMajor") {
          this.$bus.$emit("findMajor", search);
        } else {
          this.$router.push({
            path: "findMajor",
            query: {
              search: search
            }
          });
        }
      } else if (this.select == "3") {
        if (this.$route.path == "/notice") {
          this.$bus.$emit("notice", search);
        } else {
          this.$router.push({
            path: "notice",
            query: {
              search: search
            }
          });
        }
      } else {
        if (this.$route.path == "/findSchool") {
          this.$bus.$emit("findSchool", search);
        } else {
          this.$router.push({
            path: "findSchool",
            query: {
              search: search
            }
          });
        }
      }
    },
    // 路由跳转
    routerPush(e) {
      console.log("打印e", e);
      if (this.$route.path == e.path) return;
      if (e.path == "/notice") {
        this.select = "3";
      } else if (e.path == "/findMajor") {
        this.select = "2";
      } else if (e.name == "调查问卷") {
        this.questionNaire();
      } else {
        this.select = "1";
      }
      if (e.path) {
        this.$router.push({
          path: e.path
        });
      }
    }
  }
};
</script>

<style scoped>
.search_all {
  display: flex;
  align-items: center;
  width: 470px;
  height: 40px;
  overflow: hidden;
  border: rgb(224, 224, 224) 1px solid;
  border-radius: 5px;
  padding: 0 3px 0 0;
}

.search_all > div:nth-child(1) {
  width: 75%;
  height: 100%;
  /* padding-left: 10px; */
  box-sizing: border-box;
}

.search_all > div:nth-child(1) > input {
  width: 95%;
  height: 100%;
  background: none;
  outline: none;
  border: none;
}

.search_all > div:nth-child(2) {
  width: 25%;
  height: 85%;
  background-color: var(--text-color);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 15px;
  border-radius: 5px;
  cursor: pointer;
}

.el-button--goon.is-active,
.el-button--goon:active {
  background: #ff6500;
  border-color: #ff6500;
  color: #fff;
}

.el-button--goon:focus,
.el-button--goon:hover {
  background: #ff6600af;
  border-color: #ff6600af;
  color: #fff;
}

.el-button--goon {
  color: #fff;
  background-color: var(--text-color);
  border-color: var(--text-color);
}

.small_box {
  flex: 1;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  color: #0a0a0a;
  font-weight: 700;
  padding-bottom: 12px;
}

.small_box_bottom {
  border-bottom: var(--text-color) 2px solid;
  color: var(--text-color);
}

.lists_css_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;

  font-weight: bold;
}

.top_display_css {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top_login_display_css {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: end;
}

.top_login_display_css > div {
  cursor: pointer;
}

/deep/ .el-input-group__prepend {
  border: none !important;
  border-right: 1px solid #dcdfe6 !important;
  width: 40px !important;
}

/deep/ .el-input__inner {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue